import React from "react";
import UserProfileMenu from "./UserProfileMenu";

const DashboardHeader = ({ lastConsultation = null }) => {
  const userName = localStorage.getItem("userName") || "User";

  const getInitials = (name) => {
    return name
      .split(" ")
      .filter(Boolean)
      .map((item) => item[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-5">

      <div className="flex items-center justify-between mb-6">

        {/* ================= LEFT ================= */}
        <div className="flex items-center gap-4">

          {/* Avatar */}
          <div
            className="
              w-12
              h-12
              rounded-full
              bg-[#eeeafd]
              text-[#1D3A73]
              flex
              items-center
              justify-center
              font-bold
              text-sm
              flex-shrink-0
            "
          >
            {getInitials(userName)}
          </div>

          {/* Welcome */}
          <div>
            <h1 className="text-xl font-bold text-gray-800">
              Welcome back, {userName}
            </h1>

            <p className="text-xs text-gray-500 mt-1">
              {lastConsultation
                && `Last consultation ${lastConsultation}`
                }
            </p>
          </div>

        </div>

        {/* ================= RIGHT ================= */}
        <UserProfileMenu />

      </div>

    </div>
  );
};

export default DashboardHeader;